import { createCollection } from '@rocketlane/state-db';
import { ProjectAPI } from 'api/project';
const routeUpdate = async ({ id, changes, metadata })=>{
    const projectId = Number(id);
    // Archive toggle → dedicated endpoints, which take no body and return void
    // (so the collection commits the optimistic `archived` flag). Routed BEFORE
    // the payload guard below: an archive carries no `UpdateProjectPayload`, and
    // requiring one would make the only sensible call fail.
    if ((changes === null || changes === void 0 ? void 0 : changes.archived) !== undefined) {
        await (changes.archived ? ProjectAPI.archiveProject(projectId) : ProjectAPI.unarchiveProject(projectId));
        return undefined;
    }
    const payload = metadata === null || metadata === void 0 ? void 0 : metadata.payload;
    // Guard: a fire-and-forget tx swallows handler throws (preflight rule 2). If
    // the caller didn't carry the payload, fail loudly rather than no-op.
    if (payload == null) {
        throw new Error(`updateProject: missing payload metadata for ${String(id)}`);
    }
    return ProjectAPI.updateProject(projectId, payload);
};
export const projectCollection = createCollection({
    id: 'projects',
    getKey: (p)=>p.projectId,
    // Project has no monotonic version field — always-replace, with merge-mode
    // pushes (list fetchers) preserving omitted fields. Out-of-order safety comes
    // from the per-mutation seq guard + the per-entity refetch generation guard
    // in `fetchers.ts`.
    isNewer: ()=>true,
    onUpdate: routeUpdate,
    onDelete: async ({ id })=>{
        await ProjectAPI.deleteProject(Number(id));
    }
});
/**
 * Imperative read of a project from the collection. Replaces dead
 * `queryClient.getQueryData(getProjectDetailQueryKey(...))` reads.
 */ export const getProjectFromCollection = (projectId)=>projectCollection.get(projectId);
